import { Inject, Injectable } from "@angular/core";
import saveAs from 'file-saver';
import { Platform } from "ionic-angular";
import { Observable } from "rxjs";
import { EventNameAnalytics } from "../../helpers/event-name-analytics";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import { FileDownloaderProvider } from "../../providers/file-downloader/file-downloader";
import { LoopBackAuth } from "../../shared/sdk";
import {
    RequestAttendanceStatisticsDto, RequestDownloadExcelDto,
    RequestDownloadPdfDto,
    RequestSendEmailExcelDto,
    RequestSendEmailPdfDto
} from './../../shared/nestjs/gd-only/dto/attendance-report.dto';
import { AttendanceReportApi } from './../../shared/nestjs/gd-only/services/attendance-report.api';
import { NestApiProvider } from './../../shared/nestjs/nest-api';
import { ViewAttReportApi } from './../../shared/sdk/services/custom/ViewAttReport';

@Injectable()
export class AttendanceReportBloc {
    constructor(
        @Inject(LoopBackAuth) protected auth: LoopBackAuth,
        private attendanceReportApi: AttendanceReportApi,
        private platform: Platform,
        private fileDownloaderProvider: FileDownloaderProvider,
        private nestApiProvider: NestApiProvider,
        private viewattreportApi: ViewAttReportApi,
        private analyticsProvider: AnalyticsProvider
    ) { }


    downloadExcel(data: RequestDownloadExcelDto): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
        return this.attendanceReportApi.downloadExcel(data);
    }

    downloadExcelLB(data): Promise<any> {
        return new Promise(async (resolve, reject) => {
            console.log(data);
            resolve('Download Success')
        })
    }

    generateExcel(data) {
        if (this.platform.is('cordova')) {
            this.fileDownloaderProvider.downloadExcelBlob(data, 'Attendance Report')
        } else {
            saveAs(data, 'Attendance Report.xlsx')
        }
    }

    downloadPdf(data: RequestDownloadPdfDto): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
        return this.attendanceReportApi.downloadPdf(data);
    }

    generatePdfLB(data): Promise<any> {
        return new Promise(async (resolve, reject) => {
            console.log(data);
            resolve('Download Success')
        })
    }

    generatePdf(data) {
        if (this.platform.is('cordova')) {
            this.fileDownloaderProvider.downloadPdfBlob(data, 'Attendance Report')
        } else {
            saveAs(data, 'Attendance Report.pdf')
        }
    }

    sendExcel(data): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
                    let dataNest: RequestSendEmailExcelDto = new RequestSendEmailExcelDto();
                    dataNest.listEmp = data.listEmp;
                    dataNest.startDate = data.startDate;
                    dataNest.endDate = data.endDate;
                    dataNest.companyId = data.companyId;
                    dataNest.email = data.email;
                    dataNest.fullName = data.fullname;
                    dataNest.isActive = data.isActive;
                    dataNest.worklocationCodes = data.worklocationCodes;
                    dataNest.showUnknownStatus = data.showUnknownStatus;
                    return this.attendanceReportApi.reportSendEmailExcel(dataNest)
                } else {
                    data.sendEmail = true;
                    return this.viewattreportApi.download(data);
                }
            })
    }

    sendPdf(data): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    let dataNest: RequestSendEmailPdfDto = new RequestSendEmailPdfDto();
                    dataNest.listEmp = data.listEmp;
                    dataNest.startDate = data.startDate;
                    dataNest.endDate = data.endDate;
                    dataNest.companyId = data.companyId;
                    dataNest.email = data.email;
                    dataNest.fullName = data.fullname;
                    return this.attendanceReportApi.reportSendEmailPdf(dataNest)
                } else {
                    data.sendEmail = true;
                    return this.viewattreportApi.pdfmake(data);
                }
            })
    }

    generatePreview(data): Observable<any> {
        return this.viewattreportApi.pdf2img(data);
    }

    dowloadAttendanceStatistics(data): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    let dataNest: RequestAttendanceStatisticsDto = new RequestAttendanceStatisticsDto();
                    dataNest.listEmp = data.listEmp;
                    dataNest.email = data.email;
                    dataNest.fullName = data.fullName;
                    dataNest.startDate = data.startDate;
                    dataNest.endDate = data.endDate;
                    dataNest.isActive = data.isActive;
                    return this.attendanceReportApi.dowloadAttendanceStatistics(dataNest)
                }
            })
    }
}



// WEBPACK FOOTER //
// ./src/bloc/report/attendance-report.bloc.ts